<template>
<div>
  <v-card flat class="voucher-card">
  <v-card-title primary-title>
    Vouchers
    <v-spacer />
    <v-btn @click="dialog = true" color="success">Cadastrar Voucher</v-btn>
  </v-card-title>
  <v-card-text>
    <v-list v-for="voucher in vouchers" :key="voucher._id">
      <v-list-item  class="voucher-item">
        <v-list-item-content>
          <v-list-item-title>{{voucher.nome}}</v-list-item-title>
          <v-list-item-subtitle>Empresa: <strong>{{voucher.idEmpresa}}</strong> | Unidade: <strong>{{voucher.unidade}}</strong> | Convenio: <strong>{{voucher.idConvenio}}</strong></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon>
            <v-icon color="success">mdi-pencil</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider />

    </v-list>
  </v-card-text>
</v-card>
    <v-dialog v-model="dialog" persistent :overlay="false" max-width="600px">
        <v-card flat>
            <v-card-title primary-title>
                Cadastrar um voucher
            </v-card-title>
            <v-card-text>
              <v-text-field outlined v-model="voucher.nome" label="Nome do voucher"></v-text-field>
              <v-select :loading="loadEmpresa" :items="empresas" v-model="empresa" label="Empresa" item-text="nomeEmpresa" item-value="idEmpresa"></v-select>
              <v-select :disabled="unidades.length <= 0" :loading="loadUnidade" :items="unidades" v-model="unidade" label="Unidade" item-text="nomeUnidade" item-value="idUnidade"></v-select>
              <v-text-field outlined v-model="voucher.idConvenio" label="Id do convenio"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="error" @click="dialog = false">Cancelar</v-btn>
                <v-btn :loading="load" @click="cadastrarVoucher" :disabled="!voucher.nome" color="success">Cadastrar</v-btn>
              </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import voucherService from '../../../services/voucher.service'
import adminUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'Voucher',
  data () {
    return {
      dialog: false,
      vouchers: [],
      voucher: {},
      empresas: [],
      unidades: [],
      unidade: '',
      empresa: '',
      loadEmpresa: false,
      msgErro: '',
      msgSucesso: '',
      loadUnidade: false,
      alert: false,
      load: false
    }
  },
  methods: {
    listarVouchers () {
      voucherService.listarVouchers().then((response) => {
        if (response.status == 200) {
          this.vouchers = response.data
        } else {
          this.msgErro = 'Erro ao listar vouchers'
          this.alert = true
        }
      })
    },
    cadastrarVoucher () {
      this.voucher.idUnidade = this.unidade
      this.voucher.idEmpresa = this.empresa
      this.load = true
      voucherService.cadastrarVoucher(this.voucher).then((response) => {
        if (response.status == 200) {
          this.msgSucesso = 'Voucher cadastrado com sucesso'
          this.alert = true
          this.dialog = false
        } else {
          this.msgErro = 'Erro ao cadastrar voucher'
          this.alert = true
        }
      }).finally(() => {
        this.load = false
        this.listarVouchers()
      })
    },
    listarEmpresas () {
      this.loadEmpresa = true
      this.unidade = ''
      adminUnidadeService.administradorUnidade.listarEmpresas().then((response) => {
        if (response.status == 200) {
          this.empresas = response.data
        } else {
          this.msgErro = 'Erro ao listar empresas'
          this.alert = true
        }
      }).finally(() => {
        this.loadEmpresa = false
      })
    },
    /** Método para listar Unidades */
    listarUnidades () {
      this.loadUnidade = true
      adminUnidadeService.administradorUnidade.listarUnidades(this.empresa).then((response) => {
        if (response.status == 200) {
          this.unidades = response.data
        } else {
          this.msgErro = 'Erro ao listar unidades'
          this.alert = true
        }
      }).finally(() => {
        this.loadUnidade = false
      })
    }
  },
  mounted () {
    this.listarVouchers()
  },
  watch: {
    dialog (val) {
      if (val) {
        this.listarEmpresas()
      }
    },
    empresa (val) {
      if (val !== '') {
        this.listarUnidades()
      }
    }
  }
}
</script>

<style scoped>

</style>
